import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AiOpportunity, AiOpportunitiesState } from './AiOpportunitiesInterface';

const initialState: AiOpportunitiesState = {
  opportunities: [],
};

export const aiOpportunitiesSlice = createSlice({
  name: 'aiOpportunities',
  initialState,
  reducers: {
    setOpportunities: (state, action: PayloadAction<AiOpportunity[]>) => {
      state.opportunities = action.payload;
    },
    resetOpportunities: () => initialState,
  },
});

export const { setOpportunities, resetOpportunities } = aiOpportunitiesSlice.actions;

export default aiOpportunitiesSlice.reducer;
